import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { Farm } from '../../domain/entities/Farm'
import { IFarmRepository } from '../../domain/repositories/IFarm.repository'
import { FarmClient } from './FarmClient.abstract'
import { FarmSchema } from '../schemas/Farm.schema'

export class FarmRepositoryApiAdapter implements IFarmRepository {
	private readonly _endpoint = '/v2/Fazenda'

	constructor(private readonly _httpClient: FarmClient) {}

	async getAll(): Promise<Farm[]> {
		const response = await this._httpClient.get(this._endpoint)

		if (response.status !== HttpStatusCodeEnum.Ok) return []

		return FarmSchema.array().parse(response.data)
	}
}
